import React from "react";
import "./style.css";

const Home = () => {
  return (
    <div className="home">
      <h1>Visitor Pass Management</h1>
    </div>
  );
};

export default Home;
